<template>
  <main class="main search-page" role="main">
    <div class="inner" :id="`scrollable${path}`" ref="scrollable">
      <div class="search2">
        <!-- <form> -->
        <div class="form">
          <ul class="form-ul">
            <li class="form-li">
              <div class="form-ttl">
                <!-- 현재 설정된 주소 -->
                <span>{{ $t('search.main.section.current_location') }}</span>
              </div>
              <div class="form-in">
                <label class="label">
                  <input
                    type="text"
                    :value="`${currentPosition?.address ?? ''} ${currentPosition?.addressDetail ?? ''}`"
                    disabled
                  />
                </label>
                <!-- 변경 -->
                <button class="yd-cta yd-cta--secondary" @click="$router.push('/address/find')">
                  {{ $t('search.main.button.change') }}
                </button>
              </div>
            </li>
          </ul>
        </div>
        <!-- </form> -->
      </div>
      <!--현재 설정된 주소-->

      <div class="bar1"></div>

      <div class="search">
        <!-- <form> -->
        <div class="form">
          <ul class="form-ul">
            <li class="form-li">
              <div class="form-ttl">
                <!--필수값: essen-->
                <span>{{ $t('search.main.section.search_target') }}</span>
              </div>
              <div class="form-in">
                <label class="label">
                  <input
                    name="상품 및 상점, 태그 검색"
                    type="text"
                    v-model="param.searchText"
                    :placeholder="$t('search.main.input.search_bar')"
                    class="i-search"
                    @keydown.enter="fnSearch"
                  />
                  <!--                    @input="fnSearch"-->

                  <button @click.stop="fnClear">
                    <i class="i-input-delete"></i>
                  </button>
                </label>
                <button class="yd-cta yd-cta--primary" @click="fnSearch">
                  <!--검색-->
                  {{ $t('search.main.button.search') }}
                </button>
              </div>
            </li>
          </ul>
        </div>
        <!-- </form> -->
      </div>

      <!-- 첫 진입 검색화면이면 true, 검색 결과 화면이면 false -->
      <template v-if="!isShowResult">
        <div class="search-word">
          <ul class="top">
            <li class="tit">
              <!--                최근 검색어-->
              {{ $t('search.main.section.recent_search_keyword') }}
            </li>
            <li class="delete" @click="fnAllDeleteKeyword">
              <!--              전체삭제-->
              {{ $t('search.main.button.remove_all') }}
            </li>
          </ul>

          <!------------------------------------------------------------------------------------>
          <!---------------------------------- 최근 검색어 영역 ---------------------------------->
          <!------------------------------------------------------------------------------------>
          <ul class="word-list-ul">
            <li
              v-for="(keyword, index) in recentSearchKeyword"
              :key="`recent_${index}`"
              @click.self="fnKeywordSearch('Recent', keyword)"
            >
              {{ keyword }}
              <!--              {{ Util.translator(item, 'keyword') }} -->
              <i class="i-delete-16" @click="fnDeleteKeyword(index)" />
            </li>
          </ul>
        </div>

        <!------------------------------------------------------------------------------------>
        <!---------------------------------- 추천 검색어 영역 ---------------------------------->
        <!------------------------------------------------------------------------------------>
        <div class="search-word">
          <ul class="top">
            <li class="tit">
              {{ $t('search.main.section.recommend_search_keyword') }}
            </li>
          </ul>

          <ul class="word-list-ul">
            <li
              v-for="(keyword, index) in recommendedKeyword"
              :key="`search_key_${index}`"
              @click="fnKeywordSearch('Recommend', keyword)"
            >
              {{ Util.translator(keyword, 'keyword') }}
            </li>
          </ul>
        </div>

        <div class="bar1"></div>

        <div class="best-search">
          <h3>{{ $t('search.main.section.popular_search_keyword') }}</h3>
          <p>{{ $t('search.main.section.popular_search_keyword_info') }}</p>

          <!------------------------------------------------------------------------------------>
          <!----------------------------------- 인기 검색 순위 ----------------------------------->
          <!------------------------------------------------------------------------------------>
          <ul class="best-list">
            <!--            TODO: TRANSITION-->
            <transition-group name="slide-fade">
              <li
                v-for="(item, index) in keywordRank"
                :key="`best_${index}`"
                class="li-transition"
                @click="attachToSearch(item)"
              >
                <span class="num">{{ index + 1 }}</span>
                {{ item.keyword }}
              </li>
            </transition-group>
          </ul>
        </div>
      </template>

      <template v-else>
        <!--          상점 / 상품 검색 탭-->
        <!--          상점 / 상품 검색 탭-->
        <!--          상점 / 상품 검색 탭-->
        <div class="tab">
          <div class="inner">
            <div class="btn-wrap">
              <button :class="{ on: isColored('product') }" @click="fnSwitch('product')">
                <span>{{ $t('my.fav.segmented_control.product.label.title') }}</span>
              </button>
              <button :class="{ on: isColored('store') }" @click="fnSwitch('store')">
                <span>{{ $t('my.fav.segmented_control.store.label.title') }}</span>
              </button>
            </div>
          </div>
        </div>

        <template v-if="currentSearchMode === 'store'">
          <!---------------------------------------------------------------------------->
          <!------------------------------ 추천 상점 리스트 ------------------------------>
          <!---------------------------------------------------------------------------->
          <div class="store">
            <h3>{{ $t('search.main.section.recommend_store') }}</h3>
            <ul class="store-ul">
              <li class="store-li" v-if="recommendedStoreList.length === 0">
                <no-data :message="$t('admin.store.product.no_data')" />
              </li>
              <li
                v-else
                class="store-li"
                v-for="(item, index) in recommendedStoreList"
                :key="`recommend_store_${index}`"
              >
                <ul class="store-list-ul" @click="goToStore(item)">
                  <li class="left">
                    <img
                      v-if="item.files"
                      :src="getImagePath(item.files[0]?.storedFileName, 'origin')"
                      :alt="$t('admin.store.basic.info.image')"
                    />
                    <img
                      v-else
                      :src="require('/src/assets/static/images/skeleton-food02.svg')"
                      :alt="$t('admin.store.basic.info.image')"
                    />
                  </li>
                  <li class="right">
                    <div class="name">{{ Util.translator(item, 'name') }}</div>

                    <div class="line1">
                      <div class="star">
                        <i class="i-star-12"></i>
                        {{ item.star ? item.star.toFixed(1) : 0.0 }}
                        <span>({{ item.reviewCount ? item.reviewCount : 0 }})</span>
                      </div>
                      <div class="menu">
                        {{ Util.translator(item, 'products') }}
                      </div>
                    </div>

                    <div class="line2">
                      <!-- 최소, 최대 평균 배달시간 -->
                      <template v-if="item.minimumDeliveryDuration && item.maximumDeliveryDuration">
                        <i class="i-time" />
                        {{ item.minimumDeliveryDuration }}{{ $t('search.main.card.minutes') }}~
                        {{ item.maximumDeliveryDuration }}{{ $t('search.main.card.minutes') }}
                        <span></span>
                      </template>
                      <!-- 현재 설정된 위치와 store별 위도&경도 비교하여 거리 계산 -->
                      <template v-if="item.latitude && item.longitude"> {{ calcDistance(item) }}km </template>
                    </div>
                    <div class="line3">
                      <!-- 기본 배달팁 -->
                      {{ $t('search.main.card.delivery_fee') }}
                      <span>{{ calcDeliveryFee(item) }}</span>

                      <!-- 최소주문금액 -->
                      <template v-if="item.minimumPriceForDelivery">
                        {{ $t('search.main.card.required_pay_amount') }}
                        <span>{{ toVn(item.minimumPriceForDelivery) }}</span>
                      </template>
                    </div>

                    <ul class="state">
                      <li
                        class="ing yd-badge yd-badge--business"
                        :class="item.businessStatus && item.businessStatus.toLowerCase()"
                      >
                        <!--                      {{ STORE_STATUS[item.businessStatus] }}-->
                        {{ Util.translator(STORE_STATUS[item.businessStatus]) }}
                      </li>
                      <li class="package yd-badge yd-badge--packing" v-if="item.isSupportPacking">
                        {{ $t('common.packing') }}
                      </li>
                      <li class="card yd-badge yd-badge--payment-card" v-if="item.isViaCard">
                        {{ $t('common.via_card') }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="bar1"></div>

          <!---------------------------------------------------------------------------->
          <!------------------------------ 일반 상점 리스트 ------------------------------>
          <!---------------------------------------------------------------------------->
          <div class="store">
            <h3>{{ $t('search.main.section.normal_store') }}</h3>
            <ul class="store-ul">
              <li class="store-li" v-if="storeList.length === 0">
                <no-data :message="$t('admin.store.product.no_data')" />
              </li>
              <li v-else class="store-li" v-for="(item, index) in storeList" :key="`search_result_${index}`">
                <ul class="store-list-ul" @click="goToStore(item)">
                  <li class="left">
                    <img
                      v-if="item.files"
                      :src="getImagePath(item.files[0].storedFileName, 'origin')"
                      :alt="$t('admin.store.basic.info.image')"
                    />
                    <img
                      v-else
                      :src="require('/src/assets/static/images/skeleton-food02.svg')"
                      :alt="$t('admin.store.basic.info.image')"
                    />
                  </li>
                  <li class="right">
                    <div class="name">{{ Util.translator(item, 'name') }}</div>

                    <div class="line1">
                      <div class="star">
                        <i class="i-star-12"></i>
                        {{ item.star ? item.star.toFixed(1) : 0.0 }}
                        <span>({{ item.reviewCount ? item.reviewCount : 0 }})</span>
                      </div>
                      <div class="menu">
                        {{ Util.translator(item, 'products') }}
                      </div>
                    </div>

                    <div class="line2">
                      <!-- 최소, 최대 평균 배달시간 -->
                      <template v-if="item.minimumDeliveryDuration && item.maximumDeliveryDuration">
                        <i class="i-time" />
                        {{ item.minimumDeliveryDuration }}{{ $t('search.main.card.minutes') }} ~
                        {{ item.maximumDeliveryDuration }}{{ $t('search.main.card.minutes') }}
                        <span></span>
                      </template>
                      <!-- 현재 설정된 위치와 store별 위도&경도 비교하여 거리 계산 -->
                      <template v-if="item.latitude && item.longitude"> {{ calcDistance(item) }}km </template>
                    </div>

                    <div class="line3">
                      <!-- 기본 배달팁 -->
                      {{ $t('search.main.card.delivery_fee') }}
                      <span>{{ calcDeliveryFee(item) }}</span>

                      <!-- 최소주문금액 -->
                      <template v-if="item.minimumPriceForDelivery">
                        {{ $t('search.main.card.required_pay_amount') }}
                        <span>{{ toVn(item.minimumPriceForDelivery) }}</span>
                      </template>
                    </div>

                    <ul class="state">
                      <li
                        class="ing yd-badge yd-badge--business"
                        :class="item.businessStatus && item.businessStatus.toLowerCase()"
                      >
                        <!--                      {{ STORE_STATUS[item.businessStatus] }}-->
                        {{ Util.translator(STORE_STATUS[item.businessStatus]) }}
                      </li>
                      <li class="package yd-badge yd-badge--packing" v-if="item.isSupportPacking">
                        {{ $t('common.packing') }}
                      </li>
                      <li class="card yd-badge yd-badge--payment-card" v-if="item.isViaCard">
                        {{ $t('common.via_card') }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li
                class="infinite"
                v-observe-visibility="{
                  callback: fetch,
                  throttle: 100
                }"
                :key="infinite"
              ></li>
            </ul>
          </div>
        </template>

        <!-------------------------------------- 상품 탭 -------------------------------------->
        <!-------------------------------------- 상품 탭 -------------------------------------->
        <!-------------------------------------- 상품 탭 -------------------------------------->
        <template v-else>
          <div class="store likes">
            <ul class="store-ul">
              <li class="store-li no-data" v-if="products?.length === 0">
                <no-data :message="$t('admin.store.product.no_data')" />
              </li>

              <li v-else class="store-li" v-for="(item, index) in products" :key="`product_${index}`">
                <ul class="store-list-ul" @click="goToProduct(item)">
                  <li class="left">
                    <img
                      :src="
                        item.files
                          ? getImagePath(item.files[0]?.storedFileName, 'origin')
                          : require('@/assets/static/images/skeleton-food03.svg')
                      "
                      alt="Product_image"
                    />
                  </li>
                  <li class="right">
                    <div class="name" name="상품명">
                      {{ Util.translator(item, 'name') }}
                    </div>

                    <div class="line1 price">
                      <div class="dis" v-if="item.discountRate">
                        {{ toVn(item.price) }}
                      </div>
                      <div class="star" name="가격">
                        {{
                          item.discountRate
                            ? toVn(Number((item.price - item.price * item.discountRate).toFixed(0)))
                            : toVn(item.price)
                        }}
                      </div>
                    </div>

                    <div class="line2">
                      <!--              상점이름-->
                      {{ Util.translator(item.store, 'name') }}
                    </div>

                    <div class="line3">
                      <!--                거리-->
                      {{ $t('store.segmented_control.information.store.street') }}
                      <span>
                        {{
                          Util.getDistance(
                            currentPosition?.latitude ?? 0,
                            currentPosition?.longitude ?? 0,
                            item.store.latitude ?? 0,
                            item.store.longitude ?? 0
                          ).toFixed(1)
                        }}km
                      </span>
                      <span class="min-price">{{
                        $t('my.fav.segmented_control.product.label.required_pay_amount')
                      }}</span>
                      <span class="price">
                        <!--                최소주문금액-->
                        {{ toVn(item.store.minimumPriceForDelivery) }}</span
                      >
                    </div>

                    <ul class="state">
                      <li
                        class="ing yd-badge yd-badge--business"
                        :class="item.store.businessStatus && item.store.businessStatus.toLowerCase()"
                      >
                        <!--                영업상태-->
                        {{ Util.translator(STORE_STATUS[item.store.businessStatus]) }}
                      </li>
                      <li class="package yd-badge yd-badge--packing" v-if="item.store.isSupportPacking">
                        <!--                포장가능-->
                        {{ $t('common.packing') }}
                      </li>
                      <li class="card yd-badge yd-badge--online" v-if="item.store.isViaOnlinePayment">
                        {{ $t('order.on_going.section.payment_type.online') }}
                        <!--                    {{ $t('search.main.card.store_status.credit_card') }}-->
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li
                class="infinite"
                v-observe-visibility="{
                  callback: productFetch,
                  throttle: 300
                }"
                :key="infinite"
              ></li>
            </ul>
          </div>
        </template>
      </template>
    </div>
  </main>
</template>

<script setup>
import { normalizeSearchProductRouteIdentifier } from '@/router/searchProductFlow';
import { computed, nextTick, onBeforeMount, onUnmounted, ref, onActivated, onDeactivated, watch } from 'vue';
import Util from '@/common/utils/Util';
import { cloneDeep } from 'lodash';
import { useRoute, useRouter } from 'vue-router';
import { getImagePath } from '@/common/constants/ConstCode';
import NoData from '@/components/views/nodata/index';
import { toVn } from '@/common/utils/Currency';
import { recoverScroll, remindScroll } from '@/common/utils/ScrollManager';
import { useI18n } from 'vue-i18n';
import store from '@/store';

const route = useRoute();
const { query, path } = route;
const { push } = useRouter();
const constantList = store.getters['constant/getConstant'];
const { STORE_STATUS } = constantList;

// TODO 추천/일반상점 리스트 길이에 따른 fetch 확인
onBeforeMount(() => {
  if (query.searchText) {
    store.commit('layout/setIsShare', false);
    param.value.searchText = query.searchText;
    fnSearch();
  }
  preFetch();
});

onUnmounted(() => {
  store.commit('product/initList');
  store.commit('store/purgeStoreList');
  store.commit('store/purgeRecommendedStoreList');
  store.commit('store/setStorePage');
  store.commit('store/setStoreTotalPage');
  store.commit('store/setRecommendedStorePage');
  store.commit('store/setRecommendedTotalPage');
});

onActivated(async () => {
  isActive = true;
  await nextTick();
  recoverScroll(path, { behavior: 'auto' });
  showShareIcon(isShowResult.value);
});

onDeactivated(() => {
  isActive = false;
});

const currentPosition = computed(() => {
  const position = store.getters['user/getUserPosition'];
  param.value.latitude = position.latitude;
  param.value.longitude = position.longitude;
  return position;
});
const isShowResult = ref(false);
const scrollable = ref(null);
const { t } = useI18n();
const param = ref({
  latitude: '',
  longitude: '',
  searchText: '',
  isRecommended: false
});

// Meta
const infinite = ref(1);
const storeList = computed(() => store.getters['store/getStoreList']);
const products = computed(() => store.getters['product/getProducts']);
const recommendedStoreList = computed(() => store.getters['store/getRecommendedStoreList']);
const recentSearchKeyword = computed(() => store.getters['search/getRecentSearchKeyword']);
const recommendedKeyword = computed(() => store.getters['search/getRecommendedKeyword']);
const keywordRank = computed(() => store.getters['search/getKeywordRank']);

/**
 * 상품 및 상점 검색
 */
let isActive = true;
let isRefreshing = false;
let isFetching = false;
let searchVersion = 0;
let pendingRequest = Promise.resolve();
let submittedParam = null;

const resetResults = () => {
  store.commit('store/purgeStoreList');
  store.commit('store/setStorePage');
  store.commit('store/setStoreTotalPage');
  store.commit('store/purgeRecommendedStoreList');
  store.commit('store/setRecommendedStorePage');
  store.commit('store/setRecommendedTotalPage');
  store.commit('product/initList');
};

const fnSearch = async () => {
  if (!param.value.searchText.trim()) return;
  const version = ++searchVersion;
  let cloneParam = cloneDeep(param.value);
  cloneParam.latitude = currentPosition.value.latitude;
  cloneParam.longitude = currentPosition.value.longitude;
  const mode = currentSearchMode.value;
  isRefreshing = true;
  isShowResult.value = true;
  showShareIcon(true);
  store.commit('dynamiclink/flushQuery');
  store.commit('dynamiclink/setQuery', param.value.searchText);

  // Finish an older page request before resetting its shared Vuex list.
  pendingRequest = pendingRequest.catch(() => {}).then(async () => {
    if (version !== searchVersion) return;
    resetResults();
    if (scrollable.value) {
      scrollable.value.scrollTop = 0;
      remindScroll(path, { top: 0 });
    }
    submittedParam = cloneParam;
    await store.dispatch('search/saveKeywordCollection', cloneParam.searchText);
    if (version !== searchVersion) return;
    if (mode === 'product') {
      await store.dispatch('product/fetchProducts', cloneParam);
    } else {
      await store.dispatch('store/fetchStoreList', cloneParam);
    }
    if (version !== searchVersion) return;
    await store.dispatch('store/fetchRecommendedStoreList', cloneParam);
  });
  try {
    await pendingRequest;
  } finally {
    if (version === searchVersion) {
      isRefreshing = false;
      infinite.value += 1;
    }
  }
};

/**
 * 공유 아이콘 표시
 */
const showShareIcon = (isShow) => {
  const layout = Object.assign({}, store.getters['layout/getRouteLayout']);
  layout.isShare = isShow;
  store.commit('layout/setRouteLayout', layout);
};

/**
 * 추천 검색어, 최근 검색어로 검색
 * */
const fnKeywordSearch = async (type, keyword) => {
  isShowResult.value = true;

  // 추천 검색어로 검색
  if (type === 'Recommend') param.value.searchText = Util.translator(keyword, 'keyword');

  // 최근 검색어로 검색
  if (type === 'Recent') param.value.searchText = keyword;
  await fnSearch();
};
const fnAllDeleteKeyword = () => {
  store.commit('search/recentSearchDeleteAll');
};
const fnDeleteKeyword = (index) => {
  store.commit('search/spliceByIndex', index);
};

const fnSwitch = async (mode) => {
  if (currentSearchMode.value === mode) return;
  currentSearchMode.value = mode;
  await fnSearch();
};

const fetchPage = async (isVisible, mode, action) => {
  if (!isVisible || !isActive || route.path !== path || !isShowResult.value) return;
  if (isRefreshing || isFetching || currentSearchMode.value !== mode || !submittedParam) return;
  isFetching = true;
  pendingRequest = store.dispatch(action, cloneDeep(submittedParam));
  try {
    await pendingRequest;
  } finally {
    isFetching = false;
  }
};

const fetch = (isVisible) => fetchPage(isVisible, 'store', 'store/fetchStoreList');
const productFetch = (isVisible) => fetchPage(isVisible, 'product', 'product/fetchProducts');

watch(
  () => store.getters['search/getFilter'],
  () => {
    if (isActive && route.path === path && isShowResult.value) fnSearch();
  },
  { deep: true }
);

const preFetch = () => {
  store.dispatch('search/fetchRecommendedKeyword');
  store.dispatch('search/fetchKeywordRank');
};
/**
 * input란 바인딩 clear
 */
const fnClear = () => {
  const version = ++searchVersion;
  submittedParam = null;
  isRefreshing = false;
  pendingRequest = pendingRequest.catch(() => {}).then(() => {
    if (version === searchVersion) resetResults();
  });
  param.value.searchText = '';
  isShowResult.value = false;
  showShareIcon(isShowResult.value);
  store.commit('store/purgeStoreList');
  store.commit('store/purgeRecommendedStoreList');
};
const calcDistance = ({ latitude, longitude }) => {
  const userPosition = store.getters['user/getUserPosition'];
  return Util.getDistance(userPosition.latitude, userPosition.longitude, latitude, longitude).toFixed(1);
};
const attachToSearch = async ({ keyword }) => {
  //hide
  param.value.searchText = keyword;
  await fnSearch();
};
const thisMode = ref('');
const isColored = (nowIn) => {
  return currentSearchMode.value.includes(nowIn);
};
const currentSearchMode = ref('product');

const goToStore = ({ storeNo }) => {
  remindScroll(path);
  push(`/shop/${storeNo}/product`);
};
const goToProduct = (item) => {
  const storeNo = normalizeSearchProductRouteIdentifier(item?.storeNo);
  const productNo = normalizeSearchProductRouteIdentifier(item?.productNo);
  if (!storeNo || !productNo) return;
  const product = cloneDeep(item);
  if (product.files && product.files.length > 0) {
    product.file = product.files[0];
  }

  remindScroll(path);
  store.commit('product/setProduct', product);
  push({ name: 'SearchProductDetail', params: { storeNo, productNo } });
};

/**
 * 배달팁 계산
 * @param item
 * @returns {string|*|string}
 */
const calcDeliveryFee = (item) => {
  const free = t('search.result.card.free');
  const {
    baseDeliveryFee,
    baseDeliveryFeeLimit,
    increaseDeliveryFeePer,
    additionalDeliveryFee,
    maximumDeliveryFee,
    latitude,
    longitude
  } = item;
  const user = store.getters['user/getUserPosition'];

  const distance = Math.round(Util.getDistance(user.latitude, user.longitude, latitude, longitude).toFixed(1));

  let fee = baseDeliveryFee; // 배달팁
  // let fee = 0; // 배달팁

  if (distance <= baseDeliveryFeeLimit) return fee == 0 ? free : toVn(Number(fee));

  let count = distance - baseDeliveryFeeLimit;

  while (increaseDeliveryFeePer > 0 && count > 0) {
    count -= increaseDeliveryFeePer;
    fee += additionalDeliveryFee;
  }

  if (fee >= maximumDeliveryFee) return maximumDeliveryFee == 0 ? free : maximumDeliveryFee;

  return fee == 0 ? free : toVn(Number(fee));
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>

<style scoped lang="scss">
.search-page {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  background: #fff;
  color: #26313b;
  font-size: 1.4rem;
  overflow-x: hidden;
}

.search-page > .inner {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  padding: 1rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.search-page .search2,
.search-page .search {
  margin: 0;
}

.search-page .search2 {
  margin-bottom: 1rem;
}

.search-page .bar1 {
  width: 100%;
  height: 1px;
  margin: 1rem 0;
  background: #eef1f3;
}

.search-page .form,
.search-page .form-ul,
.search-page .form-li {
  margin: 0;
  padding: 0;
}

.search-page .form-li {
  list-style: none;
}

.search-page .form-ttl {
  margin-bottom: 0.5rem;
  color: #697780;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.4;
}

.search-page .form-in {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
}

.search-page .form-in > .label {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.search-page .form-in input {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 4.8rem;
  min-width: 0;
  padding: 0 3.8rem 0 1.2rem;
  border: 1px solid #dfe5e8;
  border-radius: 1.2rem;
  outline: none;
  background: #fff;
  color: #26313b;
  font-size: 1.4rem;
}

.search-page .form-in input:focus {
  border-color: #00aedd;
  box-shadow: 0 0 0 0.2rem rgba(0, 174, 221, 0.12);
}

.search-page .form-in input:disabled {
  border-color: #e6ecef;
  background: #f8fafb;
  color: #52636d;
  opacity: 1;
}

.search-page .form-in .label > button {
  position: absolute;
  top: 50%;
  right: 0.6rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  transform: translateY(-50%);
}

.search-page .form-in > button {
  flex: 0 0 auto;
  width: auto;
  min-width: 6.4rem;
  height: 4.8rem;
  margin: 0;
  padding: 0 1.2rem;
  border: 0;
  border-radius: 1rem;
  background: #00aedd;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 700;
  white-space: nowrap;
}

.search-page .search-word {
  margin: 0;
  padding: 0;
  color: #26313b;
  font-size: 1.4rem;
}

.search-page .search-word .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  margin: 1.2rem 0 0.8rem;
  padding: 0;
}

.search-page .search-word .top .tit {
  color: #52636d;
  font-size: 1.3rem;
  font-weight: 700;
}

.search-page .search-word .top .delete {
  flex: 0 0 auto;
  color: #87939a;
  font-size: 1.2rem;
  cursor: pointer;
}

.search-page .word-list-ul {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.search-page .word-list-ul > li {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0.7rem 1rem;
  border: 1px solid #e0e7ea;
  border-radius: 999px;
  background: #fff;
  color: #52636d;
  line-height: 1.3;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.search-page .best-search {
  margin: 0;
  padding: 0.4rem 0 1rem;
}

.search-page .best-search h3 {
  margin: 0;
  color: #26313b;
  font-size: 1.6rem;
}

.search-page .best-search p {
  margin: 0.4rem 0 0;
  color: #87939a;
  font-size: 1.2rem;
}

.search-page .best-search .best-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem 1rem;
  width: 100%;
  height: auto;
  min-height: 0;
  margin: 1rem 0 0;
  padding: 0;
}

.search-page .best-search .best-list > li {
  min-width: 0;
  margin: 0;
  padding: 0.8rem 0;
  border-bottom: 1px solid #eef1f3;
  color: #26313b;
  font-size: 1.4rem;
  line-height: 1.4;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.search-page .best-search .best-list .num {
  display: inline-block;
  min-width: 2rem;
  margin-right: 0.6rem;
  color: #00aedd;
  font-weight: 700;
  text-align: center;
}

.search-page .tab {
  margin: 1rem 0;
  padding: 0;
}

.search-page .tab > .inner {
  padding: 0;
}

.search-page .tab .btn-wrap {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.4rem;
  padding: 0.4rem;
  border: 1px solid #e1e8eb;
  border-radius: 1.2rem;
  background: #f6f8f9;
}

.search-page .tab .btn-wrap > button {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 4.2rem;
  margin: 0;
  padding: 0 0.8rem;
  border: 0;
  border-radius: 0.9rem;
  background: transparent;
  color: #75838b;
  font-size: 1.4rem;
  font-weight: 600;
}

.search-page .tab .btn-wrap > button.on {
  background: #e5f8fc;
  color: #008da9;
  font-weight: 700;
}

.search-page .store {
  margin: 1rem 0 0;
  padding: 0;
}

.search-page .store > h3 {
  margin: 0 0 0.8rem;
  color: #26313b;
  font-size: 1.6rem;
}

.search-page .store > .store-ul {
  display: grid;
  gap: 1rem;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.search-page .store > .store-ul > .store-li {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  list-style: none;
}

.search-page .store-list-ul {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0.8rem;
  border: 1px solid #eceff1;
  border-radius: 1.2rem;
  background: #fff;
  box-shadow: 0 0.2rem 0.8rem rgba(38, 50, 56, 0.1);
  cursor: pointer;
}

.search-page .store-list-ul > .left {
  flex: 0 0 8rem;
  width: 8rem;
  height: 8rem;
  min-width: 0;
  margin: 0 1.2rem 0 0;
  overflow: hidden;
  border-radius: 0.8rem;
}

.search-page .store-list-ul > .left img {
  display: block;
  width: 8rem;
  height: 8rem;
  border-radius: 0.8rem;
  background: #f5f5f5;
  object-fit: cover;
}

.search-page .store-list-ul > .right {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
}

.search-page .store-list-ul > .right .name {
  margin: 0;
  color: #212121;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.search-page .store-list-ul > .right .line1,
.search-page .store-list-ul > .right .line2,
.search-page .store-list-ul > .right .line3 {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.3rem 0.8rem;
  min-width: 0;
  margin-top: 0.3rem;
  color: #52636d;
  font-size: 1.2rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.search-page .store-list-ul > .right .line1 .star {
  color: #212121;
  font-weight: 700;
}

.search-page .store-list-ul > .right .line1 .star span,
.search-page .store-list-ul > .right .line1 .menu {
  color: #87939a;
  font-weight: 500;
}

.search-page .store-list-ul > .right .line1.price .star,
.search-page .store-list-ul > .right .line3 span.price {
  color: #00aedd;
  font-weight: 700;
}

.search-page .store-list-ul > .right .line1.price .dis {
  color: #a1abb0;
  text-decoration: line-through;
}

.search-page .store-list-ul .state {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  min-width: 0;
  margin: 0.5rem 0 0;
  padding: 0;
}

.search-page .store-list-ul .state > li {
  max-width: 100%;
  margin: 0;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  background: #f1f3f4;
  color: #546e7a;
  font-size: 1.2rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.search-page .store-list-ul .state > .ing {
  background: #e8f7ed;
  color: #257a47;
}

.search-page .store-list-ul .state > .package {
  background: #eaf9fd;
  color: #167f8a;
}

.search-page .store-list-ul .state > .card {
  background: #eef2ff;
  color: #4e5c8a;
}

@media (max-width: 42rem) {
  .search-page .form-in {
    gap: 0.6rem;
  }

  .search-page .form-in > button {
    min-width: 5.8rem;
    padding: 0 1rem;
  }

  .search-page .store-list-ul > .left,
  .search-page .store-list-ul > .left img {
    width: 7.2rem;
    height: 7.2rem;
  }

  .search-page .store-list-ul > .left {
    flex-basis: 7.2rem;
    margin-right: 0.9rem;
  }
}
</style>

/* *Created on 2023-08-28 *ProjectName user */

<script>
export default {
  name: 'SEARCH'
};
</script>
